var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-nav"},_vm._l((_vm.mapNavList),function(item,index){return _c('MapNavButton',{key:index,attrs:{"label":item.label,"idle":item.icon.idle,"pressed":item.icon.pressed,"active":_vm.selectedItem === item.route},on:{"click":function($event){return _vm.mapNavHandle(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }